module.exports = __webpack_public_path__ + "img/bg-login.85b2cead.jpg";